module.exports = __webpack_public_path__ + "img/flag-icon.fdd0af7f.svg";